import { i as E } from "./errors-Jh6CB33H.js";
var N = /* @__PURE__ */ ((e) => (e[e.REJECTED = 0] = "REJECTED", e[e.REPLACED = 1] = "REPLACED", e[e.CANCELLED = 2] = "CANCELLED", e[e.EXCEPTION = 3] = "EXCEPTION", e[e.LEDGER_ERROR = 4] = "LEDGER_ERROR", e[e.INSUFFICIENT_FUNDS = 5] = "INSUFFICIENT_FUNDS", e[e.PENDING = 6] = "PENDING", e[e.OTHER = 7] = "OTHER", e))(N || {});
const C = (e) => E(e, "ACTION_REJECTED") ? 0 : E(e, "TRANSACTION_REPLACED") ? 1 : E(e, "INSUFFICIENT_FUNDS") ? 5 : e.message.includes("Ledger") ? 4 : e.message.includes("UserRefusedOnDevice") ? 0 : parseInt(e.code) === -32002 && e.message && e.message.includes("pending") ? (console.warn("Transaction pending in wallet error"), 6) : e.message.includes("cancelled") && !(e != null && e.cancelled) ? 0 : E(e, "CANCELLED") ? 2 : E(e, "CALL_EXCEPTION") ? 3 : (E(e, "UNKNOWN_ERROR"), 7), u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TransactionErrors: N,
  parseEthersError: C
}, Symbol.toStringTag, { value: "Module" }));
export {
  N as T,
  C as p,
  u as w
};
